import { TabPanel } from '@headlessui/react';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getTiers } from '../../api/tiers.api';
import MembershipCard from '../../components/membership/card';
import MembershipCardSkeleton from '../../components/membership/card-skeleton';
import { IMembershipTier } from '../../types/tiers.types';

const TiersBenefits: React.FC = () => {
  const params = useParams();

  const { data: membershipTiers, isLoading } = useQuery({
    queryKey: ['getTiers', params.id],
    queryFn: () => getTiers(params.id || ''),
    enabled: !!params.id,
    refetchOnWindowFocus: false
  });

  if (isLoading) {
    return (
      <TabPanel as={'div'} className={'my-4 flex flex-col gap-y-2'}>
        {Array.from({ length: 3 }).map((_, index) => (
          <MembershipCardSkeleton
            key={index}
            className={'max-w-full px-4 py-2'}
          />
        ))}
      </TabPanel>
    );
  }

  if (!membershipTiers?.success) {
    return <div>Error</div>;
  }

  return (
    <TabPanel as={'div'} className={'my-4 flex flex-col gap-y-2'}>
      {membershipTiers?.data?.tiers?.map((tier: IMembershipTier, index: number) => {
        const currentTierIndex = membershipTiers.data.currentTierIndex ?? 0;
        const isCurrentTier = index === currentTierIndex;
        const isAboveCurrentTier = index > currentTierIndex;

        const progressPoints = isAboveCurrentTier
          ? 0
          : (tier.nextTierEarnedPoints ?? 0);
        const progressTotal =
          index === membershipTiers.data.tiers!.length - 1
            ? '- / -'
            : (tier.nextTierThreshold ?? 0);

        return (
          <MembershipCard
            isBrand={params.id !== 'aye'}
            key={tier.tierName + index}
            className={'max-w-full px-4 py-2'}
            brandName={tier.pointName || ''}
            rewardName={tier.tierName}
            rewardPoints={progressPoints}
            rewardTotalPoints={progressTotal}
            rewardAvailablePoints={null}
            steppedCreditPerRm={tier.pointReward.steppedCreditPerRm}
            valueApplied={tier.pointReward.valueApplied?.toString()}
            themeColor={tier.colorHex || '#FE724C'}
            description={tier.description || undefined}
            subDescription={tier.subDescription || undefined}
            currencyCode={membershipTiers.data.fiat_currency_code ?? undefined}
            isCurrentTier={isCurrentTier}
            isAboveCurrentTier={isAboveCurrentTier}
          />
        );
      })}
    </TabPanel>
  );
};
export default TiersBenefits;
